
<div>
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h4>Templates</h4>
    <div>
      <button class="badgebutton success active mr-2" @click="showCategoryModal(null)">
        <i class="far fa-folder-plus mr-1"></i>
        Add Category
      </button>
      <button class="badgebutton success active" @click="addTemplate">
        <i class="far fa-plus mr-1"></i>
        Add Template
      </button>
    </div>
  </div>

  <div class="bg-white p-3 shadow-sm mb-3 rounded-sm">
    <div class="row">
      <div class="col-4">
        <div class="input-group input-group-sm">
          <select class="form-control" v-model="templateType">
            <option v-for="option in templateTypeOptions" :value="option.id" :key="option.id">{{ option.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-8">
        <div class="input-group input-group-sm mr-3 text-nowrap">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="far fa-search"></i>
            </span>
          </div>
          <input type="text" v-model="searchString" class="form-control" placeholder="Search..." aria-label="Search for templates" />
        </div>
      </div>
    </div>
  </div>

  <div style="height: calc(100vh - 280px); overflow-y: auto; overflow-x: hidden">
    <div v-if="loading" class="text-center">
      <loading-spinner></loading-spinner>
    </div>
    <div v-if="!loading">
      <!-- Categories with templates -->
      <div v-for="group in filteredCategories" :key="group.category ? group.category.guid : 'uncategorized'" class="mb-4">
        <!-- Category Header -->
        <div
          class="category-header d-flex justify-content-between align-items-center p-2 bg-light rounded-top cursor-pointer"
          @click="toggleCategory(group.category ? group.category.guid : 'uncategorized')"
        >
          <div class="d-flex align-items-center">
            <i
              class="far mr-2"
              :class="isCategoryExpanded(group.category ? group.category.guid : 'uncategorized') ? 'fa-chevron-down' : 'fa-chevron-right'"
            ></i>
            <i v-if="group.category && group.category.icon" :class="group.category.icon" class="mr-2"></i>
            <strong>{{ group.category ? group.category.name : 'Uncategorized' }}</strong>
          </div>
          <div v-if="group.category" @click.stop>
            <button
              class="btn btn-xs btn-info mr-2"
              v-if="canMoveUp(group.category)"
              @click="moveCategoryUp(group.category)"
            >
              <i class="far fa-arrow-alt-up"></i>
            </button>
            <button
              class="btn btn-xs btn-info mr-2"
              v-if="canMoveDown(group.category)"
              @click="moveCategoryDown(group.category)"
            >
              <i class="far fa-arrow-alt-down"></i>
            </button>
            <button class="btn btn-xs btn-info mr-2" @click="showCategoryModal(group.category)">
              <i class="far fa-pencil-alt"></i>
            </button>
            <button class="btn btn-xs btn-info" @click="confirmDeleteCategory(group.category)">
              <i class="far fa-trash"></i>
            </button>
          </div>
        </div>

        <!-- Templates in category -->
        <div v-show="isCategoryExpanded(group.category ? group.category.guid : 'uncategorized')" class="category-content">
          <div v-if="!group.templates.length" class="bg-white p-3 text-muted text-center">
            No templates in this category yet. Create one and assign this category to it.
          </div>
          <template-card
            v-for="(template, index) in group.templates"
            :key="template.template.id"
            :template="template"
            :is-last="index === group.templates.length - 1"
            @edit-category="showTemplateCategoryModal"
            @edit-schedule="editSchedule"
            @edit-availability="editAvailability"
            @remove="confirmRemoveTemplate"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Schedule Modal -->
  <b-modal
    ref="editTemplateModal"
    id="editTemplateModal"
    hide-footer
    hide-header
    body-class="modal-body-wo"
    size="lg"
    :no-close-on-backdrop="false"
    @hidden="loadData"
  >
    <board-item-schedule-edit :current-template-id="currentTemplateId"></board-item-schedule-edit>
  </b-modal>

  <!-- Availability Modal -->
  <b-modal
    ref="editAvailabilityModal"
    id="editAvailabilityModal"
    hide-footer
    hide-header
    body-class="modal-body-wo"
    size="lg"
    :no-close-on-backdrop="true"
    @hidden="loadData"
  >
    <board-item-template-availability-edit :current-template-id="currentTemplateId"></board-item-template-availability-edit>
  </b-modal>

  <!-- Category Edit Modal -->
  <b-modal
    ref="categoryEditModal"
    id="categoryEditModal"
    hide-footer
    hide-header
    body-class="modal-body-wo"
    size="lg"
    :no-close-on-backdrop="true"
    @hidden="loadData"
  >
    <template-category-edit-modal
      :category="editingCategory"
      :board-guid="boardId"
      :default-sort-order="allCategories.length"
    />
  </b-modal>

  <!-- Template Category Select Modal -->
  <b-modal
    ref="templateCategoryModal"
    id="templateCategoryModal"
    hide-footer
    hide-header
    body-class="modal-body-wo"
    size="lg"
    :no-close-on-backdrop="true"
    @hidden="loadData"
  >
    <template-category-select-modal
      :template="currentTemplate"
      :categories="allCategories"
    />
  </b-modal>

  <router-view></router-view>
</div>
